// extracted by mini-css-extract-plugin
export default {"Tabs":"Menu_Tabs__EljSh","Active":"Menu_Active__ehpgK","Header":"Menu_Header__2h5xc"};